import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiSDK } from '../../contexts/apiSdkContext';

type TTokens = {
  accessToken: string;
  refreshToken: string;
};

type TRefreshTokensHook = {
  isError: boolean;
  isLoading: boolean;
  refreshTokenMutation: (refreshToken: string) => Promise<TTokens | undefined>;
};

function useRefreshTokens(): TRefreshTokensHook {
  const sdk = useApiSDK();

  const queryClient = useQueryClient();

  const {
    mutateAsync: refreshTokenMutation,
    isError,
    isLoading,
  } = useMutation({
    mutationFn: async (refreshToken: string) => {
      console.log(refreshToken);
      const data = await sdk.auth.refresh(refreshToken);
      console.log('TOKEN MOST LIKELY REFRESED? More below');
      console.log(data);
      if (data) {
        localStorage.setItem('accessToken', data.accessToken);
        localStorage.setItem('refreshToken', data.refreshToken);
        localStorage.setItem('accessTokenExp', (Date.now() + 50 * 60 * 1000).toString());

        sdk.setAuthToken(data.accessToken);
        return data;
      }

      return undefined;
    },
    onSuccess: async () => {
      console.log('TOKEN REFRESH SUCCESS');
      await queryClient.invalidateQueries(['access-tokens']);
      await queryClient.invalidateQueries(['refresh-tokens']);
    },
  });

  return { isError, isLoading, refreshTokenMutation };
}

export { useRefreshTokens };
